import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'
import Home from '../views/Home/home'
import News from '../views/News/news'
import Product from '../views/Product/product'
import Case from '../views/Case/case'
import About from '../views/About/about'
import newsList from '../views/News/news-list'
import newsDetails from '../views/News/news-details.vue'
import productList from '../views/Product/product-list'
import productDetails from '../views/Product/product-details'
import caseList from '../views/Case/case-list.vue'
import caseDetails from '../views/Case/case-details.vue'
import aboutMain from '../views/About/about-main.vue'
import data from '../views/data/index.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: index,
    meta: {
      title: '重庆巨通交通'
    },
    redirect:'/home',
    children : [
      {
        path : '/home',
        component : Home,
        meta: {
          title: '重庆巨通交通'
        },
      },
      {
        path : '/news',
        component : News,
        children : [
          {
            path : 'details',
            component :newsDetails,
            meta: {
              title: '重庆巨通交通-新闻详情',
            },
          },
          {
            path : '/',
            component : newsList,
            meta: {
              title: '重庆巨通交通-新闻'
            },
          }
        ]
      },
      {
        path : '/product',
        component : Product,
        children : [
          {
            path : '/',
            component : productList,
            meta: {
              title: '重庆巨通交通-产品'
            },
          },
          {
            path:'details',
            component : productDetails,
            meta: {
              title: '重庆巨通交通-产品详情'
            },
          }
        ]
      },
      {
        path : '/case',
        component : Case,
        meta: {
          title: '重庆巨通交通-案例'
        },
        children : [
          {
            path : '/',
            component : caseList,
            meta: {
              title: '重庆巨通交通-案例'
            },
          },
          {
            path : 'details',
            component : caseDetails,
            meta: {
              title: '重庆巨通交通-案例详情'
            },
          }
        ]
      },
      {
        path : '/about',
        component : About,
        children : [
          {
            path : '/',
            component : aboutMain,
            meta: {
              title: '重庆巨通交通-关于'
            },
          },
        ]
      }
    ]
  },
  {
    path : '/data',
    component : data,
    meta: {
      title: '产品追溯介绍'
    },
  },
]
const router = new VueRouter({
  routes,
  scrollBehavior(){
    return { x: 0, y: 0 }
  },
  mode: 'hash',
  base : '/'
})  

export default router
